export enum ExportTagType {
    Download = 'DOWNLOAD',
    Consultation = 'CONSULTATION'
}
